module.exports = __webpack_public_path__ + "img/category-title02.4d57c792.png";